import * as moment from 'moment';

export class FilterModel {
  private _startDate: Date;
  private _endDate: Date;
  private _cgicCode: string;
  private _duration: number;
  private _dateFilterVerbiage: string;

  constructor(cgicCode: string, duration: number, dateFilterVerbiage?: string, startDate?: Date, endDate?: Date) {
    this._startDate = startDate || moment().subtract(duration - 1, 'days').toDate();
    this._endDate = endDate || new Date();
    this._cgicCode = cgicCode;
    this._duration = duration;
    this._dateFilterVerbiage = dateFilterVerbiage || 'Filter by date range';
  }

  get dateFilterVerbiage(): string {
    return this._dateFilterVerbiage;
  }

  set dateFilterVerbiage(txt: string) {
    this._dateFilterVerbiage = txt;
  }

  get duration(): number {
    return this._duration;
  }

  set duration(days: number) {
    this._duration = days;
  }

  get startDate(): Date {
    return this._startDate;
  }

  set startDate(dt: Date) {
    this._startDate = dt;
  }

  get endDate(): Date {
    return this._endDate;
  }

  set endDate(dt: Date) {
    this._endDate = dt;
  }

  get cgicCode(): string {
    return this._cgicCode;
  }

  set cgicCode(code: string) {
    this._cgicCode = code;
  }
}
